<template>
	<v-dialog v-model="dialog" max-width="600px" @click:outside="$emit('close')" @keydown.esc="$emit('close')">
		<v-card :disabled="form.busy" :loading="form.busy">
			<v-card-title>
				<!-- <span class="headline">{{ momentDate }}</span> -->
				<v-spacer></v-spacer>
				<v-btn icon @click="$emit('close')">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-form :value="valid" lazy-validation ref="form">
					<v-row>
						<v-col>
							<v-autocomplete
								v-model="form.user"
								:items="search.items"
								:loading="search.loading"
								:search-input.sync="search.text"
								item-text="name"
								item-value="id"
								:label="$t('customer')"
								prepend-icon="mdi-account"
								no-filter
							>
								<template v-slot:item="{ item }">
									<v-col>
										<v-row>
											<v-col>
												<v-tooltip top>
													<template v-slot:activator="{ on }">
														<v-icon class="pr-5" :color="userIconColor(item.state)" v-on="on">
															{{ userIcon(item.type, item.state) }}
														</v-icon>
													</template>
													<span>{{ $t('user.types.' + item.type) }} {{ $t('user.states.' + item.state) }}</span>
												</v-tooltip>
												{{ item.name }}
											</v-col>
										</v-row>

										<v-row>
											<v-col>
												<div class="d-flex align-center body-1"><v-icon class="pr-5">mdi-at</v-icon>{{ item.email }}</div>
											</v-col>
										</v-row>

										<v-row>
											<v-col>
												<div class="d-flex align-center body-1">
													<v-icon class="pr-5">mdi-cellphone-iphone</v-icon>{{ item.phone }}
												</div>
											</v-col>
										</v-row>
									</v-col>
									<v-divider class="my-3"></v-divider>
								</template>
								<template v-slot:no-data>
									<v-col>
										<v-row justify="center" align="center">
											<v-btn text block large @click="createUserDialog = true">
												<v-icon>mdi-account-plus</v-icon>
											</v-btn>
										</v-row>
									</v-col>
								</template>
							</v-autocomplete>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-radio-group v-model="form.hair" row>
								<v-radio
									v-for="service in hairServices"
									:key="service.id"
									:label="`${service.name} (${service.duration}min/${service.price}Kč)`"
									:value="service.id"
								></v-radio>
							</v-radio-group>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-radio-group v-model="form.beard" row>
								<v-radio
									v-for="service in beardServices"
									:key="service.id"
									:label="`${service.name} (${service.duration}min/${service.price}Kč)`"
									:value="service.id"
								></v-radio>
							</v-radio-group>
						</v-col>
					</v-row>

					<v-row v-if="form.hair !== null || form.beard !== null">
						<v-col>
							<v-checkbox
								hide-details
								multiple
								v-for="service in otherServices"
								:key="service.id"
								:label="`${service.name} (${service.duration}min/${service.price}Kč)`"
								:value="service.id"
								v-model="form.other"
							></v-checkbox>
						</v-col>
					</v-row>

					<v-row justify="space-between">
						<!-- <v-col> -->
						<v-btn outlined color="primary" @click="book(time.id)" class="mb-2" v-for="time in times" :key="time.id">
							{{ time.time }}
						</v-btn>
						<!-- </v-col> -->
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<!-- <v-btn color="primary" @click="submit" v-if="canBook" :loading="form.busy">{{ $t('book') }}</v-btn> -->
				<!-- <v-btn color="primary" @click="submit" v-if="!canBook" :disabled="!canGetTimes" :loading="form.busy">{{ $t('times') }}</v-btn> -->
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbarSuccess" bottom color="success" left :absolute="true">
			{{ $t('messages.success.save') }}
			<v-btn dark text @click="snackbarSuccess = false">
				{{ $t('close') }}
			</v-btn>
		</v-snackbar>
		<create-update-user-dialog
			v-if="createUserDialog"
			closeOnSubmit
			@close="createUserDialog = false"
			@user="
				search.items = [$event]
				form.user = $event.id
			"
		/>
	</v-dialog>
</template>

<script>
import Form from 'vForm'
import _ from '~/plugins/lodash'
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			form: new Form({
				date: null,
				user: null,
				time: null,
				hair: null,
				beard: null,
				other: []
			}),
			search: {
				text: '',
				loading: false,
				items: []
			},
			dialog: true,
			createUserDialog: false,
			users: [],
			times: [],
			searchText: null
		}
	},

	created() {
		this.form.date = this.date
	},

	computed: {
		...mapGetters({
			services: 'auth/services',
			date: 'bookings/date'
		}),
		formChange() {
			return this.form.user + this.form.hair + this.form.beard + this.form.other
		},
		canGetTimes() {
			let { user, hair, beard } = this.form
			return user !== null && (hair !== null || beard !== null)
		},
		canBook() {
			let { user, services, time } = this.form
			return user !== null && services.length > 0 && time !== null
		},
		hairServices() {
			return this.services.filter(x => x.type === 'hair')
		},
		beardServices() {
			return this.services.filter(x => x.type === 'beard')
		},
		otherServices() {
			return this.services.filter(x => x.type === 'other')
		}
	},

	watch: {
		'search.text': _.debounce(function() {
			if (this.search.text) {
				this.getUsers()
			}
		}, 300),
		formChange() {
			if (this.canGetTimes) {
				this.getTimes()
			}
		}
	},

	methods: {
		...mapActions({
			getBookings: 'bookings/getBookings'
		}),
		async getUsers() {
			this.search.loading = true
			let { data } = await this.$http.post('user/find', this.search)
			this.search.items = data
			this.search.loading = false
		},
		async getTimes() {
			try {
				let { data } = await this.form.post('booking/times')
				this.times = data
			} catch ({ response }) {
				this.times = []
				console.log(response)
			}
		},
		async book(time) {
			this.form.time = time
			let { status } = await this.form.post('booking')
			// await this.form.post('book')
			if (status === 201) {
				await this.getBookings()
				this.$emit('close')
			}
		},
		userIconColor(userState) {
			if (userState === 'verifed') {
				return 'success'
			}
			return 'red'
		},
		userIcon(userType, userState) {
			if (userType === 'user') {
				if (userState === 'verifed') {
					return 'mdi-account-check'
				}
				return 'mdi-account-alert'
			}
			if (userType === 'guest') {
				return 'mdi-ghost'
			}
			return 'mdi-account-question'
		}
	}
}
</script>

<style lang="scss" scoped></style>
